import { CImage, CSidebar, CSidebarBrand, CSidebarNav } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import AppSidebarNavItems from './AppSidebarNavItems'
import UserProfile from './UserProfile'
// sidebar nav config
import { sygnet } from '../../assets/brand/sygnet'
import { useTypedSelector } from '../../stateStore'
import AIMLBridgeLogo from '../../assets/images/logo/ai_bridge_logo_207X65.png'
import RayBizTechLogo from '../../assets/images/logo/RbtLogo.svg'
import MobileLogoRBT from '../../assets/images/logo/logo.png'
import MobileLogoAiMl from '../../assets/images/logo/ai_ml_icon.png'
import { reduxServices } from '../../reducers/reduxServices'

const AppSidebar = () => {
  const sidebarShow = useTypedSelector(
    reduxServices.app.selectors.getSidebarShow,
  )

  const tenantKey = localStorage.getItem('tenantKey')
  const logoImg =
    tenantKey === 'RAYBIZTECH' || tenantKey === 'RAYBIZTECHR'
      ? RayBizTechLogo
      : AIMLBridgeLogo
  const mobileImg =
    tenantKey === 'RAYBIZTECH' || tenantKey === 'RAYBIZTECHR'
      ? MobileLogoRBT
      : MobileLogoAiMl
  const fromLocal = localStorage.getItem('employeeId') as string
  const [isDisabled, setIsDisabled] = useState(false)
  const disabledStyle: React.CSSProperties = {
    pointerEvents: 'none',
    opacity: 0.5,
  }
  /* eslint-disable */
  return (
    <>
      <CSidebar
        className="main-sidebar"
        position="fixed"
        unfoldable={!sidebarShow}
        style={isDisabled ? disabledStyle : {}}
      >
        <CSidebarBrand className="d-none d-md-flex main-logo">
          <Link to={'/dashboard'}>
            <CImage
              src={logoImg}
              alt="logo"
              className={`cursor-pointer ${sidebarShow ? '' : 'hide-logo'}`}
            />
            <CImage
              src={mobileImg}
              alt="logo"
              className={`cursor-pointer ${sidebarShow ? 'hide-logo' : ''}`}
            />
            <CIcon className="sidebar-brand-narrow" icon={sygnet} height={35} />
          </Link>
        </CSidebarBrand>
        <CSidebarNav>
          <div className={`${'smin' in localStorage ? 'resize-me' : ''}`}>
            <UserProfile fromLocal={fromLocal} />
          </div>
          <AppSidebarNavItems setIsDisabled={setIsDisabled} />
        </CSidebarNav>
      </CSidebar>
    </>
  )
}

export default React.memo(AppSidebar)
